import type { MessageKey } from '@/i18n';
import { LIVE_FAMILIES } from '@/lib/liveFamilies';

export interface SoonItem {
  id: string;
  /** Live products carry a translated family name; slots ship with brand titles. */
  key?: MessageKey;
  title?: string;
  art: string;
}

/** Slot titles queued behind the live pipeline, using their 366×160 key art. */
const SOON_SLOTS: SoonItem[] = [
  { id: 'gemstone-alchemist', title: 'Gemstone Alchemist', art: '/game-thumbs/366x160_EN_BevelQueen_withRP.avif' },
  { id: 'inannas-quest', title: "Inanna's Quest", art: '/game-thumbs/366x160_EN_InannaQuest_withRP.avif' },
  { id: 'temptation-garden', title: 'Temptation Garden', art: '/game-thumbs/366x160_EN_TemptationGarden_withRP.avif' },
  { id: 'cosmic-jackpot', title: 'Cosmic Jackpot', art: '/game-thumbs/366x160_EN_COSMICJACKPOT_withRP.avif' },
];

export function soonItems(): SoonItem[] {
  const live = LIVE_FAMILIES.filter((family) => !family.active).map((family) => ({
    id: family.id,
    key: family.key,
    art: family.art,
  }));

  return [...live, ...SOON_SLOTS];
}
